/**
 * RenderFormRowComponent renders a row of form fields
 * @param label - The label of the row
 * @param children - The children of the row
 * @returns The rendered row component
 */
function RenderFormRowComponent({ label, children }: { label: string, children: React.ReactNode }) {
  return (
    <div className="flex items-center gap-2 px-4 py-2 hover:bg-slate-50 rounded-md">
      <p className="w-1/3 text-sm text-slate-500">{label}</p>
      <div className="w-2/3">
        {children}
      </div>
    </div>
  );
}

export default RenderFormRowComponent;
